export const getMergedClassNames = (arr: any[]) => {
  return arr.filter((el) => el !== '').join(' ')
}

export const getUniqueKey = () => {
  const atual = window.sessionStorage.getItem('chaveAtual')
    ? parseInt(window.sessionStorage.getItem('chaveAtual') || '1')
    : 1
  window.sessionStorage.setItem('chaveAtual', String(atual + 1))
  return `_${atual}`
}

export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ]

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}

export const getIdProgramaFromHash = (hash: string) => {
  // eslint-disable-next-line no-undef
  return String(atob(hash)).replace(/^(\d+)(\/{1})(.+)$/, '$1')
}

export const getIdTurmaFromHash = (hash: string) => {
  // eslint-disable-next-line no-undef
  return String(atob(hash)).replace(/^(\d+)(\/{1})(.+)$/, '$3')
}

export class TimeOut {
  pause: () => void
  resume: () => void
  constructor(callback: () => void, delay?: number) {
    var timerId: any
    var start = Date.now()
    var remaining = delay

    this.pause = function () {
      window.clearTimeout(timerId)
      remaining! -= Date.now() - start
    }

    this.resume = function () {
      start = Date.now()
      window.clearTimeout(timerId)
      timerId = window.setTimeout(callback, remaining)
    }

    this.resume()
  }
}

export class Interval {
  status: boolean
  pause: () => void
  restart: () => void
  constructor(callback: () => void, delay?: number) {
    var intervalId: any
    var timeoutId: any
    var start: any
    var remaining = delay
    this.status = false

    this.pause = () => {
      this.status = false
      window.clearTimeout(timeoutId)
      window.clearInterval(intervalId)
      remaining = delay! - (Date.now() - start)
    }

    this.restart = () => {
      remaining = delay
      this.resume()
    }

    this.resume = () => {
      this.status = true
      start = Date.now()
      window.clearInterval(intervalId)
      window.clearTimeout(timeoutId)
      timeoutId = window.setTimeout(() => {
        callback()
        start = Date.now()
        intervalId = window.setInterval(() => {
          callback()
          start = Date.now()
        }, delay)
      }, remaining)
    }

    this.resume()
  }
  resume() {
    throw new Error('Method not implemented.')
  }
}

export const dispatchToAllYouTubeVideos = (
  command: 'pauseVideo' | 'stopVideo' | 'playVideo',
  idToExclude?: string
) => {
  const iframes = document.querySelectorAll('iframe')
  Array.from(iframes).forEach((f: HTMLIFrameElement) => {
    if (
      (!idToExclude || f.id !== idToExclude) &&
      typeof f.contentWindow?.postMessage === `function`
    ) {
      f.contentWindow?.postMessage(
        JSON.stringify({ event: 'command', func: command, args: '' }),
        '*'
      )
    }
  })
}

export const dispatchToYoutubeVideo = (
  command: 'pauseVideo' | 'stopVideo' | 'playVideo',
  id?: string
) => {
  const frame = document.querySelector(`#${id}`) as HTMLIFrameElement
  if (frame) {
    frame.contentWindow?.postMessage(
      JSON.stringify({ event: 'command', func: command, args: '' }),
      '*'
    )
  }
}

// export const isValidHTMLCode = (strCode) => {
//   const valueWithSplitCode = String(strCode).replace(/</g, '#split#<')
//   const arrOfSplittedCode = valueWithSplitCode.split('#split#')
//   const arrOfOpening = []
//   const arrOfClosing = []
//   const arrOfTags = arrOfSplittedCode
//     .map((tag) => {
//       const str = String(tag).replace(
//         /(<)(\/){0,1}(\w+){1}(\s+.+)*(>){1}(.+)*/g,
//         '$1$2$3$5'
//       )
//       if (String(str).match(/^<\/.+>$/)) {
//         arrOfClosing.push(str.replace(/\W/g, ''))
//       } else if (str) {
//         arrOfOpening.push(str.replace(/\W/g, ''))
//       }
//       return str
//     })
//     .filter((tag) => tag !== '')

//   console.log('opening', arrOfOpening)
//   console.log('closing', arrOfClosing)
//   return arrOfTags
// }
